<template>
    <div class="search_view">
        <div class="row_1">
            <div class="tap"><b>纸质图书</b></div>
        </div>
        <div class="row_2">
            <input type="text">
            <div>
                <i class="el-icon-search" @click="search"></i>
            </div>
        </div>
        <div class="row_3">
            <div class="tap" @click="openNewBookUrl">新书通告</div>
            <div class="tap" @click="openMyReaderUrl">读者荐购</div>
            <div class="tap" @click="openMyLibraryUrl">我的图书馆</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LibrarySearch',
    data() {
        return {
            newBookUrl: 'http://10.223.88.6:8080/opac/newBook',
            myReaderUrl: 'http://10.223.88.6:8080/opac/recn',
            myLibraryUrl: 'http://10.223.88.6:8080/opac/login?referer=/opac/mylibrary&subtag=submyindex&subcourse=false&rssindex=false&tag=aboutus&subbeans=false',
            searchUrl: 'http://10.223.88.6:8080/opac/search/simsearch',
        }
    },
    methods: {
        search() {
            window.open(this.searchUrl, '_blank')
        },
        openNewBookUrl() {
            window.open(this.newBookUrl, '_blank')
        },
        openMyReaderUrl() {
            window.open(this.myReaderUrl, '_blank')
        },
        openMyLibraryUrl() {
            window.open(this.myLibraryUrl, '_blank')
        }
    }
}
</script>
<style scoped>
.search_view>.row_1 .tap {
    color: white;
    cursor: pointer;
    font-size: 16px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    width: 86px;
    background: #b84e4e;
    border-radius: 3px 3px 2px 2px;
}

.search_view>.row_3 .tap {
    cursor: pointer;
}

.row_3 {
    margin-top: 30px;
    margin-left: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 50%;
    font-size: 16px;
}

.search_view {
    height: 90%;
    width: 85%;
    margin-top: 4%;
    margin-left: 3%;
    margin-bottom: 3%;
    border-radius: 5px;
    background-color: rgb(0 96 152 / 0.4);
}

.search_view>.row_2 {
    display: flex;
    height: 45px;
    border: 2px solid #000;
    border-radius: 6px;
    overflow: hidden;
    margin-left: 25px;
    width: 90%;
}

.el-icon-search {
    font-size: 40px;
    color: whitesmoke;
}

.search_view>.row_1 {
    margin-top: 30px;
    margin-left: 25px;
    margin-bottom: 25px;
}

.search_view>.row_2 input {
    flex: 1;
    padding: 0 10px;
    margin: 0;
    border: 0;
    outline: 0;
}
.search_view>.row_2 div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 4px 4px 0;
    width: 60px;
    padding: 0;
    margin: 0;
    border: 0;
    cursor: pointer;
    background-color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/LibrarySearch.vue